<template>
  <div>
    <mdb-card class="mb-4">
      <mdb-card-header>Recent Discussion</mdb-card-header>
      <mdb-card-body v-if="error">
        <error :error="error"/>
      </mdb-card-body>
      <mdb-card-body v-if="discussions.length > 0">
        <mdb-card class="mb-2 text-left"
                  v-bind:key="msg.messageId" v-for="msg in discussions">
          <mdb-card-body>
            <user-avatar :avatar="msg.member.avatar" :memberId="msg.member.id" :id="msg.member.id" :name="msg.member.name"
                         :reputation="msg.member.reputation" :size="50"/>
            <div>
              {{msg.text}} <i>"{{msg.subject}}"</i> on the forum <i>{{msg.title}}</i>.
            </div>
            <div class="text-right">
              <mdb-btn rounded size="sm" @click="viewDiscussion(msg)">View</mdb-btn>
            </div>
          </mdb-card-body>
        </mdb-card>
        <div class="text-center">
          <mdb-btn @click="forum" icon="comments" rounded size="sm">Discussion Forum</mdb-btn>
        </div>
      </mdb-card-body>
    </mdb-card>


  </div>
</template>

<script>
import error from '../common/Error'
import userAvatar from '../common/Avatar'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer} from 'mdbvue';

export default {
    name: 'RecentDiscussionSection',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbBtn,
      userAvatar,
      error
    },
    props: {
      group: {
        type: Object,
        default: null
      },
      section: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        discussions: [],
        error: null
      };
    },
    mounted() {
      if (!this.group) {
        return
      }
      this.discussions = this.section.data
    },
    methods: {
      forum: function () {
        this.$router.push("/group/" + this.group.vanityPath + "/forum")
      },
      viewDiscussion: function(forum) {
        let route = "/group/" + this.group.vanityPath + "/forum/" + forum.forumId + "?topic=" + forum.topic + "&highlight=" + forum.messageId
        this.$router.push(route)
      },
    }
  };
</script>
